/**
 * Narrow storage abstraction so persistence can be tested without a browser and
 * swapped (IndexedDB, file system) later without touching callers.
 */
export interface StorageAdapter {
  read(key: string): string | null;
  write(key: string, value: string): void;
  remove(key: string): void;
}

export const createLocalStorageAdapter = (storage: Storage = globalThis.localStorage): StorageAdapter => ({
  read: (key) => {
    try {
      return storage.getItem(key);
    } catch {
      return null;
    }
  },
  write: (key, value) => {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Quota exceeded or storage disabled. Persistence is best-effort; the app keeps running.
      console.warn('[persistence] write failed', error);
    }
  },
  remove: (key) => {
    try {
      storage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
});

export const createMemoryStorageAdapter = (): StorageAdapter => {
  const map = new Map<string, string>();
  return {
    read: (key) => map.get(key) ?? null,
    write: (key, value) => void map.set(key, value),
    remove: (key) => void map.delete(key),
  };
};
